import http from '@/services/http';
import apiEndpoints from '@/services/apiEndpoints';

const getDefaultState = () => {
  return {
    options_tables: {},
    system_codes: [],
    own_vendor_sites: [],
  };
};

const state = getDefaultState();
const getters = {
  options_tables (state) {
    return state.options_tables;
  },
  work_order_type_options (state) {
    return state.options_tables.zz_work_order_types?.map(item => ({value: item.id, text: item.work_order_type}))
  },
  own_vendor_sites (state) {
    return state.own_vendor_sites;
  },
};
const mutations = {
  SET_OPTION_TABLES (state, { data }) {
    state.options_tables = data;
  },
  UNSET_OPTION_TABLES (state) {
    state.options_tables = {};
  },
  SET_SYSTEM_CODES (state, data) {
    state.system_codes = data;
  },
  SET_OWN_VENDOR_SITES (state, data) {
    state.own_vendor_sites = data;
  }
};
const actions = {
  async getOptionsTable ({ commit }, payload) {
    const { status, data }  = await http.getWithLoading(apiEndpoints.options_tables, payload);

    if (status) {
      commit('SET_OPTION_TABLES', {data: data.result});

      return {
        status: true,
      };
    } else {
      return {
        status: false,
        errors: data.errors,
        code: data.code,
        message: data.message,
      };
    }
  },
  async getSystemCodes ({ commit }, payload) {
    const { status, data }  = await http.getWithLoading(apiEndpoints.system_codes, payload);

    if (status) {
      commit('SET_SYSTEM_CODES', data.result);

      return {
        status: true,
      };
    } else {
      return {
        status: false,
        errors: data.errors,
        code: data.code,
        message: data.message,
      };
    }
  },
  async getOwnVendorSites ({ commit }, payload) {
    const { status, data }  = await http.getWithLoading(apiEndpoints.own_vendor_sites, payload);

    if (status) {
      commit('SET_OWN_VENDOR_SITES', data.result);

      return {
        status: true,
      };
    } else {
      return {
        status: false,
        errors: data.errors,
        code: data.code,
        message: data.message,
      };
    }
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
